"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundcloudSocialLink1Schema = void 0;
exports.SoundcloudSocialLink1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/soundcloud-sociallink/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "SoundcloudSocialLink1",
    "description": "Add a soundcloud link to artists or playlists",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:soundcloud-sociallink:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "href": {
                    "type": "string",
                    "description": "e.g. `https://soundcloud.com/stephenvantran`",
                    "pattern": "^https?://soundcloud.com/"
                }
            },
            "required": [
                "href"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9zb3VuZGNsb3VkLXNvY2lhbGxpbmsvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxLQUFLLEVBQUUsMEZBQTBGO0lBQ2pHLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHVCQUF1QjtJQUNoQyxhQUFhLEVBQUUsK0NBQStDO0lBQzlELE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLGtEQUFrRDthQUNuRDtTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osTUFBTSxFQUFFO29CQUNOLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsOENBQThDO29CQUM3RCxTQUFTLEVBQUUsMkJBQTJCO2lCQUN2QzthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLE1BQU07YUFDUDtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9